export default __webpack_public_path__ + "static/media/merto-s.0dddaecd.jpg";